module.exports = __webpack_public_path__ + "media/images/menu_izq/centro_salud-66820913d3bb818bff1b0d5a123af627.svg";